import { render, staticRenderFns } from "./EmailAlert.vue?vue&type=template&id=366fd802&"
import script from "./EmailAlert.vue?vue&type=script&lang=js&"
export * from "./EmailAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports